export default {
  IMAGE_URL: '/img/',
  ICON_URL: '/Icons/'
}